import React, { Ref } from 'react';
import { StanDraggableProps } from './StanDraggable.types';
import { StanDraggableContext } from './StanDraggable.context';
import { StanDraggableZone } from './StanDraggableZone';

interface StanDraggablePropsWithRef extends StanDraggableProps {
    ref?: Ref<HTMLDivElement>;
}

export const StanDraggable = ({
    onReorder,
    onDragStart,
    onDragEnd,
    className = '',
    disabled = false,
    direction = 'vertical',
    gap = 'sm',
    placeholder,
    children,
    dragFromHandleOnly = false,
    ref,
}: StanDraggablePropsWithRef) => {
    const contextValue = {
        onReorder: onReorder || (() => {}),
        onDragStart,
        onDragEnd,
        disabled,
        direction,
        gap,
        dragFromHandleOnly,
    };

    return (
        <StanDraggableContext.Provider value={contextValue}>
            <StanDraggableZone ref={ref} className={className} direction={direction} gap={gap} disabled={disabled}>
                {placeholder && React.Children.count(children) === 0 && (
                    <div className='stan-draggable-placeholder'>{placeholder}</div>
                )}
                {children}
            </StanDraggableZone>
        </StanDraggableContext.Provider>
    );
};
